














import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class AppartBloc extends Vue {}
